import React, { useEffect, useMemo, useState } from "react";
import {
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Grid,
  Input,
  Text,
  Textarea,
  useColorModeValue
} from "@chakra-ui/react";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import CardHeader from "components/Card/CardHeader";
import { useTranslation } from "react-i18next";
import { ROUTES } from "../../../constants/routes-path";
import { useNavigate, useParams } from "react-router-dom";
import { useCustomToast } from "../../../components/CustomToast/CustomToast";
import { trafficViolationService } from "../../../services/trafficViolationService";

function TrafficViolationCancel({data}) {
  const textColor = useColorModeValue("gray.700", "white");
  const bgTextarea = useColorModeValue("white", "navy.900");
  const placeholderColor = useColorModeValue("gray.300", "gray.400");

  const { t } = useTranslation();
  const navigate = useNavigate();
  const toast = useCustomToast();
  const { id } = useParams();

  const [formData, setFormData] = useState( {
    reason: ""
  });

  const ids = useMemo(() => ({
    reason: "traffic-violation-cancel-reason",
  }), []);

  useEffect(() => {
    if (data) {
      setFormData(data);
    }
  }, [data]);

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setFormData({...formData, [e.target.name]: e.target.value});
    setErrors((prevErrors) => ({...prevErrors, [e.target.name]: ""}));
  };

  const validateForm = () => {
    let newErrors = {};

    if (!formData.reason.trim()) {
      newErrors.reason = t("traffic-violation-cancel.form.fields.reason.required");
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const onSave = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    try {
      const dataToSave = {
        motivo_cancelamento: formData.reason
      };

      await trafficViolationService.cancel(id, dataToSave);

      navigate(ROUTES.trafficViolationsPath);

      toast({
        title: t("system.notifications.success"),
        status: "success"
      });

    } catch (err) {
      toast({ title: t(err), status: "error" });
    }
  };

  return (
    <Flex direction="column" minH="89vh" align="center" pt={{sm: "120px", md: "75px"}}>
      <Card mt={"80px"}>
        <CardHeader mb="40px">
          <Flex direction="column">
            <Text color={textColor} fontSize="lg" fontWeight="bold" mb="3px">
              {t("traffic-violation-cancel.form.title")}
            </Text>
            <Text color="gray.400" fontWeight="normal" fontSize="sm">
              {t("traffic-violation-cancel.form.subtitle")}
            </Text>
          </Flex>
        </CardHeader>
        <CardBody>
          <form onSubmit={onSave}>
            <Flex direction="column" w="100%">
              <Grid gap="24px">
                <FormControl isRequired isInvalid={errors[ids.reason]}>
                  <FormLabel color={textColor} fontWeight="bold" fontSize="xs">
                    {t("traffic-violation-cancel.form.fields.reason.label")}
                  </FormLabel>
                  <Textarea
                    minH="120px"
                    name="reason"
                    value={formData.reason}
                    onChange={handleChange}
                    bg={bgTextarea}
                    _placeholder={{color: placeholderColor}}
                    placeholder={t("traffic-violation-cancel.form.fields.reason.placeholder")}
                    fontSize="xs"
                  />
                </FormControl>
              </Grid>
              <Flex justify="space-between">
                <Button
                  variant="light"
                  fontSize="sm"
                  alignSelf="flex-end"
                  mt="24px"
                  w="100px"
                  h="35px"
                  onClick={() => navigate(ROUTES.trafficViolationsPath)}
                >
                  {t("system.actions.back")}
                </Button>
                <Button
                  variant="dark"
                  fontSize="sm"
                  alignSelf="flex-end"
                  type="submit"
                  mt="24px"
                  w="100px"
                  h="35px"
                >
                  {t("system.actions.save")}
                </Button>
              </Flex>
            </Flex>
          </form>
        </CardBody>
      </Card>
    </Flex>
  );
}

export default TrafficViolationCancel;
